export const set_subscriptions = "set_subscriptions";
export const set_cancel_reasons = "set_cancel_reasons";
export const set_custom_text = "set_custom_text";
export const set_customer_data = "set_customer_data";
export const update_subscription_status = "update_subscription_status";

export const dateFilters = {
  upcoming: -1,
  threeMonths: 3,
  sixMonths: 6,
  oneYear: 12,
  allTime: 13,
};

export const EMAIL_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const default_culture_info = "en-US";
